import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { themeColorPropOr } from '@groovehq/internal-design-system/lib/util/theme'
import cn from 'classnames'
import { Tooltip, Icon } from 'shared/ui'

const IconWithTooltip = ({
  active,
  className,
  tooltip,
  tooltipPosition,
  ...rest
}) => {
  return (
    <Tooltip position={tooltipPosition} tooltip={tooltip}>
      <Icon className={cn(className, { active })} {...rest} />
    </Tooltip>
  )
}

IconWithTooltip.propTypes = {
  active: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipPosition: PropTypes.string,
}

IconWithTooltip.defaultProps = {
  active: false,
  tooltipPosition: 'bottom',
  tooltip: '',
}

export default styled(IconWithTooltip)`
  height: 32px;
  padding-top: 4px;
  color: ${themeColorPropOr('color.monochrome.mediumDark')};
  position: relative;
  top: 1px;

  // &:hover {
  //   border-radius: 4px;
  //   background-color: ${props => props.theme.color.monochrome.superLight};
  // }

  // &.active {
  //   border-radius: 4px;
  //   background-color: ${props => props.theme.color.monochrome.medium};
  // }
`
